import React, { Component } from 'react';

class NotFound extends Component {
  render() {
    return (
      <div>
        <h1>Page Not Found</h1>
        <p>The page could not be found. Please refresh the page. If you continue to see this page, please raise a redmine item.</p>
      </div>
    );
  }
}

export default NotFound;



// WEBPACK FOOTER //
// ./containers/curateHome/notFound.js